module.exports = __webpack_public_path__ + "static/media/main-bg.441c57da.png";